module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-breakpoints/gatsby-browser.js'),
      options: {"plugins":[],"queries":{"xs":"(max-width: 768px)","sm":"(min-width: 769px)","md":"(min-width: 1024px)","l":"(min-width: 1216px)"}},
    },{
      plugin: require('../node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"custom":{"families":["Visby CF"],"urls":["/fonts/stylesheet.css"]}},
    }]
